namespace('compass.hotel');

compass.require('compass.hotel.HotelCardWidget');
compass.require('compass.hotel.HotelFilter', { includeCSS : false });

compass.hotel.HotelListWidget = compass.defineWidget(function HotelListWidget(options) {
	var me = this;
	var $j = jQuery;

	var _settings = options;
	var _WUID = _settings.WUID;

	var _searchTimeOutId = null;

	var _imagePath = "crap";

	var _expandedHotels = [];
	var _filtered = false;
	var _cardWidgets = { };

	var _selectedHotel = null;
	var _showSoldOutHotels = _settings.showSoldOutHotels;
	var _requireCheckInOutDates = _settings.requireCheckInOutDates;
	var _showSimplifiedFilter = _settings.showSimplifiedFilter;
	var _filterMessage;

	var _HOTEL_RESULTS_TEXT = 'Hotel Results, select hotel to continue, ';

	var _hotels = _settings.hotels;
	var default_sort_distance = _settings.default_sort_distance;

	this.setSearchOptions = function(searchOptions) { };

	var _setImagePath = this.setImagePath = function(imagePathArg) {
		_imagePath = imagePathArg;
	};
	
	me._custom_gallery_cards_sort = function (a, b) {
		//Sort by section sort order
		if(a.sort_section === 'TOP' && b.sort_section === 'TOP' || a.sort_section === 'BOTTOM' && b.sort_section == 'BOTTOM') {
			if(a.sort_order < b.sort_order) {
				return -1;
			} else if(a.sort_order > b.sort_order) {
				return 1;
			} else {
				return 0;
			}
		}
		//Top always floats to the top
		else if(a.sort_section === 'TOP') {
			return -1;
		}
		//Top always floats to the top 
		else if(b.sort_section === 'TOP') {
			return 1;
		}
		//normal goes before bottom
		else if(a.avail && a.avail.status !== 'SOLDOUT' && b.sort_section === 'BOTTOM') {
			return -1;
		}
		//normal goes before bottom
		else if(a.sort_section === 'BOTTOM' && b.avail.status !== 'SOLDOUT') {
			return 1;
		}
		//bottom goes before soldout
		else if(a.sort_section === 'BOTTOM' && b.avail.status === 'SOLDOUT') {
			return -1;
		}
		//bottom goes before soldout
		else if(a.avail && a.avail.status === 'SOLDOUT' && b.sort_section === 'BOTTOM') {
			return 1;
		}
		//failsafe
		else {
			return 0;
		}
	};
	
	// hotel_sort will return negative if a should come before, otherwise b should come before a
	me._hotel_sort = function (a, b) {
		// if custom card, has priority sorting
		if(!a.hotelId || !b.hotelId || a.hotelId == -1 || b.hotelId == -1) {
			return me._custom_gallery_cards_sort(a, b);
		}
		// then compare sold out status, they sink down to the bottom
		else if(a.avail.status == 'SOLDOUT' && b.avail.status != 'SOLDOUT'){
			return 1; // b should come before a
		}
		else if(a.avail.status != 'SOLDOUT' && b.avail.status == 'SOLDOUT'){
			return -1; //  a should come before b
		}
		// finally compare the sort order
		else if(a.sortOrder || b.sortOrder){
			// if at least one of the hotels we're comparing has a sort order defined use it, otherwise, use a really large
			// number to make it come afterwards
			return (a.sortOrder ? a.sortOrder : 99999) - (b.sortOrder ? b.sortOrder : 99999);
		}
		// preferred always floats to the top
		else if(a.categoryPreferredHotel && !b.categoryPreferredHotel) {
			return -1; // a should come before b
		}
		else if(b.categoryPreferredHotel && !a.categoryPreferredHotel){
			return 1;// b should come before a
		}
		// hq always floats to the top
		else if(a.hqHotel && !b.hqHotel) {
			return -1; // a should come before b
		} 
		else if(b.hqHotel && !a.hqHotel){
			return 1;// b should come before a
		}
		// finally, compare the names of the hotels
		return (a.name.toLowerCase()).localeCompare(b.name.toLowerCase());
	};

	me._distance_hotel_sort = function (a, b) {
		var sortByPrice = function(a, b, sortDir) {
			return a.avail.lowestAvgRateNumeric < b.avail.lowestAvgRateNumeric ? sortDir :
				(b.avail.lowestAvgRateNumeric < a.avail.lowestAvgRateNumeric ? sortDir * -1 : 0);
		};
		// if custom card, has priority sorting
		if(!a.hotelId || !b.hotelId) {
			return me._custom_gallery_cards_sort(a, b);
		}
		// then compare sold out status, they sink down to the bottom
		else if(a.avail.status == 'SOLDOUT' && b.avail.status != 'SOLDOUT'){
			return 1; // b should come before a
		}
		else if(a.avail.status != 'SOLDOUT' && b.avail.status == 'SOLDOUT'){
			return -1; //  a should come before b
		}else if(a.sortOrder || b.sortOrder){
			// if at least one of the hotels we're comparing has a sort order defined use it, otherwise, use a really large
			// number to make it come afterwards
			return (a.sortOrder ? a.sortOrder : 99999) - (b.sortOrder ? b.sortOrder : 99999);
		}
		// preferred always floats to the top
		else if(a.categoryPreferredHotel && !b.categoryPreferredHotel) {
			return -1; // a should come before b
		}
		else if(b.categoryPreferredHotel && !a.categoryPreferredHotel){
			return 1;// b should come before a
		}
		// hq always floats to the top
		else if(a.hqHotel && !b.hqHotel) {
			return -1; // a should come before b
		}
		else if(b.hqHotel && !a.hqHotel){
			return 1;// b should come before a
		}

		else if (a.distanceUnits == b.distanceUnits) {
			//sort by distance then price if applicable
			return a.distance < b.distance ? -1 :
				(b.distance < a.distance ? 1 : sortByPrice(a, b, 0));
		}
		else if(a.distanceUnits != b.distanceUnits) {
			//distance units priority: blocks < miles < everything else
			if (a.distanceUnits == 'Blocks' || b.distanceUnits == 'Blocks') {
				return a.distanceUnits == 'Blocks' ? -1 : 1;
			}
			else if (a.distanceUnits == 'Miles' || b.distanceUnits == 'Miles') {
				return a.distanceUnits == 'Miles' ? -1 : 1;
			}
			else {
				return 0;
			}
		}
		// finally, compare the names of the hotels
		return (a.name.toLowerCase()).localeCompare(b.name.toLowerCase());
	};

	var _fireDataChanged = function() {
		// if you just pass _data the array it seems to pass the first element. possible jquery bug or "feature".
		me.trigger('dataChanged', {
			data : _hotels
		});
	};

	var _show = function(hotelId, dimHotels) {
		var widget = _cardWidgets[hotelId];
		var dimHotels = dimHotels || false;
		if(widget) {
			var elem = widget.getWidgetElem().parents('.hotelCardHolder');
			elem.data('filtered', false);
			return function() {
				if(!dimHotels){
					elem.show(200);
				}else{
					elem.show(0);
				}
				elem.delay(400);
				elem.animate({ opacity : 1 }, 600);
				elem.addClass('visibleCard');
			};
		}
	};

	var _hide = function(hotelId, dimHotels) {
		var widget = _cardWidgets[hotelId];
		var dimHotels = dimHotels || false;		
		if(widget) {
			var elem = widget.getWidgetElem().parents('.hotelCardHolder');
			elem.data('filtered', true);
			return function() {
				if(!dimHotels){
					elem.animate({ opacity : 0.5 }, 600);
				}
				elem.delay(400);
				elem.fadeOut(600, function(){elem.removeClass('visibleCard');});
				//elem.removeClass('visibleCard');
			};
		}
	};

	var _dim = function(hotelId) {

	};

	var _hotelData = function(elem) {
		return $j(elem).data('hotel');
	};

	var _buildFilterMessageText = function (numOfHotelsAvailable, totalHotels){
		var messageBeginning = 'There are ';
		var messageEnding = ' hotels ';
		// default of 'there are x hotels available'
		if(numOfHotelsAvailable == 1){
			// there is one hotel available
			messageBeginning = 'There is ';
			messageEnding = ' hotel ';
		}
		else if(numOfHotelsAvailable === 0){
			// there are no hotels available
			numOfHotelsAvailable = ' no ';
		}

		return messageBeginning + numOfHotelsAvailable + messageEnding + ' displaying out of ' + totalHotels;
	};

	var _getNumOfHotelsDisplaying = function(){
		var hotelListDiv = me.find('.hotelListDiv');
		var listOfHotels = hotelListDiv.find('.hotelCardHolder');

		// loop through all hotels and increment a count every time we find a filtered hotel to get the numhber of filtered hotels
		var numOfhotelsFilteredOut = _.reduce(listOfHotels, function(memo, curHotel){ return memo + ($j(curHotel).data('filtered') ? 1 : 0); }, 0);

		return {'numHotelsdisplaying': listOfHotels.length - numOfhotelsFilteredOut, 'total': listOfHotels.length};
	};

	// _sorter is a callback function that will be called by HotelFilter.js when hotels are to be resorted
	// it accepts 1 argument, a comparaator that determines which hotels go before others
	var _sorter = function(comparator) {
		var sort = function(a, b) {
			return comparator(_hotelData(a), _hotelData(b));
		};

		var hotelListDiv = me.find('.hotelListDiv');
		var filterWarning = hotelListDiv.find('.filterWarning');
		var listOfHotels = hotelListDiv.find('.hotelCardHolder');
		listOfHotels.sort(sort).insertBefore(filterWarning);

		var filterStruct = _getNumOfHotelsDisplaying();

		_filterMessage.text(''); // doing empty string so that SOME text change takes place every time and we get an announcement every time
		_filterMessage.text(_buildFilterMessageText(filterStruct.numHotelsdisplaying, listOfHotels.length));

		// update the header reader that doesn't get announced, but is available when choosing a list of headers
		// it will read 'Hotel Results - select hotel to continue there are 5 out of 10 hotels displaying'
		$j('#hotelResultsReader').text(_HOTEL_RESULTS_TEXT + _buildFilterMessageText(filterStruct.numHotelsdisplaying, listOfHotels.length));
	};

	var _redraw = function(hotels, availMin, dimHotels){
		var d = _d;
		var availMin = availMin || 0;
		var dimHotels = dimHotels || false;

		// replace the previous storage of hotels
		_hotels = hotels;
		var localHotels = getAvailableHotels(_hotels);
		
		// If custom gallery cards, add them to localHotels for sorting/filtering
		if(_settings.customGalleryCards) {
			localHotels = localHotels.concat(_settings.customGalleryCards);
		}

		//var localHotels = _hotels;
		localHotels.sort(me._hotel_sort);

        // find hotelcards that are not in the set. remove them.
        var currentCards = me.find('.hotelCardHolder');
        currentCards.each(function(i,e){
            var hotel_ids = _.pluck(localHotels, 'hotelId'); 
            var h = jQuery(e).data('hotel');
		
            var fh = _.find(hotel_ids,function(num){return h.hotelId === num;});
            if ( fh == null && h.hotelId !== -1){
                jQuery(e).remove();
            }
        });

		_.each(localHotels, function(curHotel) {
			// find the current hotel in the dom
			var hotelCard = me.find('.hotel_id_' + curHotel.hotelId + ', .custom_gallery_card_id_' + curHotel.custom_gallery_card_id);
			// get the hotel card holder and empty it
			if ( hotelCard.length === 0 ){
				var hotelListDiv = me.find('.hotelListDiv');
				var hotelCardHolder;
				if (!curHotel.hotelId || curHotel.hotelId === -1) {
					hotelCardHolder = _d.div({ className : 'customGalleryCardHolder hotelCardHolder visibleCard' });
				} else {
					hotelCardHolder = _d.div({ className : 'hotelCardHolder visibleCard' });
				}
				hotelListDiv.append(hotelCardHolder);
			} else{
				var hotelCardHolder = hotelCard.closest('.hotelCardHolder').empty();
			}

			if(curHotel.hotelId) {
				hotelCardHolder.data('hotel', curHotel);
				var _hotelCardWidget = new compass.hotel.HotelCardWidget(hotelCardHolder, {
					WUID : 'HotelCardWidget_' + _WUID,
					hotel : curHotel,
					meetingInfo : _settings.meetingInfo,
					displayHotelStars : _settings.displayHotelStars,
					availMin : availMin,
					hideDistance : _settings.hideDistance,
					hideNumberOfRoomsAvailable : _settings.hideNumberOfRoomsAvailable, 
					displayPriceSavings: _settings.displayPriceSavings && curHotel.avail.status === 'NORMAL'
				});
				_cardWidgets[curHotel.hotelId] = _hotelCardWidget;
				
				if(dimHotels){
					hotelCardHolder.animate({ opacity : 0.5 }, 600);
				}
			} else {
				var sort_section = curHotel.sort_section.toUpperCase();
				hotelCardHolder.data('hotel', {
					avail: {
						status: sort_section
					},
					distance: sort_section === 'TOP' ? 0 : 9999,
					hotelId: -1
				});
				var customGalleryCardWidget = new compass.hotel.CustomGalleryCardWidget(hotelCardHolder, {
					customGalleryCard: curHotel
				});
			}
		});

		// Remove the initial message once dates are selected
		me.find('.checkInOutDatesWarning').remove();
	};


	var _filter = new compass.hotel.HotelFilter(_hide, _show, _sorter, _redraw);
	var _currFilter = { };

	this.updateFilter = function(filterObj) {
		_currFilter = (filterObj || _currFilter);
		_filter.updateFilter(_currFilter, me._hotel_sort, _requireCheckInOutDates);
	};

	this.unsetFilter = function(key) {
		delete _currFilter[key];
		_filter.updateFilter(_currFilter);
	};

	var getAvailableHotels = function(hotels){
		_.map(hotels, function(hotel) {
			// if an expedia hotel has a cached rate of -1 (unavailable) in the db, we want it to display in the gallery as sold out
			if (hotel.avail.lowestAvgRateNumeric === -1) {
				hotel.avail.status = "SOLDOUT";
			}
		});
		if(_showSoldOutHotels) {
			return hotels;
		} else {
			var availableHotels = _.filter(hotels, function(hotel) {
				return (hotel.avail.status != "SOLDOUT");}
			);
			return availableHotels;
		}
	};

	this.findAvailById = function(hotel_id) {
		hotel_id = parseInt(hotel_id);
		var localHotels = _hotels;
		for(var i = 0; i < localHotels.length; i++) {
			if(localHotels[i].hotel_id === hotel_id) {
				 return localHotels[i];
			}
		}
	};

	var _setupControls = function() {

	};

	this.render = function(widgetElem) {
		var d = _d;
		var layoutclass = "gridLayout";
		widgetElem.append(
			d.reader( d.h2( {'id': 'hotelResultsReader'}, _HOTEL_RESULTS_TEXT) ),
			d.div({ className : "hotelListDiv" })
		);

		var localHotels = getAvailableHotels(_hotels);
		
		// If custom gallery cards, add them to localHotels for sorting/filtering
		if(_settings.customGalleryCards) {
			localHotels = localHotels.concat(_settings.customGalleryCards);
		}
		
		if(default_sort_distance){
			localHotels.sort(me._distance_hotel_sort);
		}else{
			localHotels.sort(me._hotel_sort);
		}
		_expandedHotels = [];
		_cardWidgets = { };
		_fireDataChanged();
		_filter.setData(_hotels);

		var hotelListDiv = me.find('.hotelListDiv').empty();
		// for the screen reader to announce how many hotels are available based on the filter selections
		_filterMessage = d.h2({id:'filterMessageText', 'aria-relevant':'additions', 'aria-live':'polite', style: {
				'position' : 'absolute', 
				left : '-999999999px', 
				height : '0px',
				width : '0px',
				overflow : 'hidden'
			}
		}).appendTo(widgetElem);
		hotelListDiv.append(_filterMessage);
		
		if (_requireCheckInOutDates === true) {
			var checkInOutWarningElement = _d.div(
				{className: "checkInOutDatesWarning"},
				'Enter your check-in and check-out dates to see available hotels.'
			);
			// When using the alternate filter, hide the element so it is unseen but still influences the DOM
			if (_showSimplifiedFilter) {
				checkInOutWarningElement.css('display', 'none');
			}
			hotelListDiv.append(checkInOutWarningElement);
		} else if(localHotels.length === 0) {
			hotelListDiv.html('Sorry,<br /> but there are no hotels available for the dates you requested.');
		} else {
			_.each(localHotels, function(hotel) {
				//Draws HotelCardWidget or CustomGalleryCardWidget
				if(hotel.hotelId) {
					var hotelCardHolder = _d.div({ className : 'hotelCardHolder visibleCard' });
					hotelCardHolder.data('hotel', hotel);
					var hotelCardWidget = new compass.hotel.HotelCardWidget(hotelCardHolder, {
						WUID : 'HotelCardWidget_' + _WUID,
						hotel : hotel,
						meetingInfo : _settings.meetingInfo,
						displayHotelStars : _settings.displayHotelStars,
						hideDistance : _settings.hideDistance,
						hideNumberOfRoomsAvailable : _settings.hideNumberOfRoomsAvailable,
						displayPriceSavings: _settings.displayPriceSavings && hotel.avail.status === 'NORMAL'
					});
					_cardWidgets[hotel.hotelId] = hotelCardWidget;
					hotelListDiv.append(hotelCardHolder);
				} else {
					var customGalleryCardHolder = _d.div({ className : 'customGalleryCardHolder hotelCardHolder visibleCard' });
					var sort_section = hotel.sort_section.toUpperCase();
					customGalleryCardHolder.data('hotel', {
						avail: {
							status: sort_section
						},
						distance: sort_section === 'TOP' ? 0 : 9999,
						hotelId: -1
					});
					// customGalleryCardHolder.data('customCard', customGalleryCard.customGalleryCardID);
					var customGalleryCardWidget = new compass.hotel.CustomGalleryCardWidget(customGalleryCardHolder, {
						customGalleryCard: hotel
					});
					hotelListDiv.append(customGalleryCardHolder);
				}
			});
		}
		hotelListDiv.append(
			_d.div({className:"filterWarning"},'Sorry! No hotels match your search or filter criteria.')
		);

		me.find('.hotelLine').hover(function() {
			var hoteldiv = this;
			var hotelLine = hoteldiv;
			var hotel = $j(hotelLine).data('hotel');
			me.trigger("hotelHovered", hotel);
			// "this" is the hover overed elem not the widget.
			$j(this).toggleClass('hotelLineHighlighted');
			$j(this).toggleClass('hotelLineNotHighlighted');
		}, function() {
			var hoteldiv = this;
			var hotelLine = hoteldiv;
			var hotel = $j(hotelLine).data('hotel');
			me.trigger("hotelHoveredOff", hotel);
			// "this" is the hover overed elem not the widget.
			$j(this).toggleClass('hotelLineHighlighted');
			$j(this).toggleClass('hotelLineNotHighlighted');
		});

	};

	var _d = jQuery.dom.getContext(this);

}, {
	WUID : 'CRAP',
	widgetName : 'HotelListWidget',
	hotels : [ ],
	displayHotelStars : true,
	showSoldOutHotels : true,
	displayPriceSavings: false
});

